import { Button } from '@/components/ui/button'
import Skeleton from 'react-loading-skeleton'

export function DateSelectionSummarySkeleton() {
  return (
    <>
      <div className="flex flex-col justify-center gap-0">
        <Skeleton width={120} height={20} />
        <Skeleton width={80} height={10} />
      </div>
      <Button disabled>Rezervovat</Button>
    </>
  )
}
